import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  KycLevel,
  KycStatus,
  UserResource,
} from "@/services/swagger/gen/models";

import { Nullable, TCustomKycStatus } from "./../../../types/index";

interface IUserState extends Omit<UserResource, "kyc_status"> {
  personal_access_token: UserResource["personal_access_token"] | null;
  kyc_status: TCustomKycStatus;
}

const initialState: IUserState = {
  kyc_errors: {},
  created_at: null,
  first_name: null,
  has_password: false,
  id: 0,
  last_name: null,
  updated_at: null,
  kyc_level: KycLevel["ZERO"],
  kyc_level_text: "",
  kyc_status: KycStatus["PROCESSING"],
  kyc_status_text: "",
  status: "ACTIVE",
  status_text: "",
  personal_access_token: null,
  mobile_number: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUserAction: (state) => {
      state.created_at = null;
      state.first_name = null;
      state.has_password = false;
      state.id = 0;
      state.last_name = null;
      state.updated_at = null;
      state.kyc_level = KycLevel["ZERO"];
      state.kyc_level_text = "";
      state.kyc_status = KycStatus["PROCESSING"];
      state.kyc_status_text = "";
      state.personal_access_token = {
        abilities: [""],
        created_at: "",
        expires_at: "",
        first_ip_address: "",
        id: 0,
        last_ip_address: "",
        last_used_at: "",
        name: "",
        password_entered_at: "",
        should_enter_password: false,
        updated_at: "",
      };
    },
    setUserDataAction: (state, action: PayloadAction<Nullable<IUserState>>) => {
      if (!action.payload) {
        return;
      }

      if (
        action.payload.kyc_level === "ZERO" &&
        action.payload.kyc_status === "APPROVED"
      ) {
        state.kyc_status = "SKIPPED";
      } else {
        state.kyc_status = action.payload.kyc_status;
      }

      state.created_at = action.payload.created_at;
      state.first_name = action.payload.first_name;
      state.has_password = action.payload.has_password;
      state.id = action.payload.id;
      state.last_name = action.payload.last_name;
      state.updated_at = action.payload.updated_at;
      state.kyc_level = action.payload.kyc_level;
      state.kyc_level_text = action.payload.kyc_level_text;
      state.kyc_status_text = action.payload.kyc_status_text;
      state.personal_access_token = action.payload.personal_access_token;
      state.mobile_number = action.payload.mobile_number;
    },
  },
});

export default userSlice.reducer;

export const { resetUserAction, setUserDataAction } = userSlice.actions;
